import { useMemo } from 'react';
import { useGetPersonDocumentTypes } from 'shared/data/walletsKyc/v1';

import { documentTypeToBackSide, documentTypeToMessage } from './usePersonDocumentTypes.constants';

export const usePersonDocumentTypes = (country: string) => {
    const { data, isLoading } = useGetPersonDocumentTypes({
        path: {
            countryCode: country,
        },
    });

    const documentTypes = useMemo(
        () =>
            (data?.items || []).map((documentType) => ({
                id: documentType,
                name: documentTypeToMessage[documentType],
                requiredBack: documentTypeToBackSide[documentType],
            })),
        [data]
    );

    return { documentTypes, isDocumentTypesLoading: isLoading };
};
